export default __webpack_public_path__ + "static/media/1862.702250b0.png";